/* eslint-disable */
import cx from 'classnames';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Modal } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';

import './EscapeList.css';
import './EscapeAdder.css';
import EscapeForm from './EscapeForm';
import ReviewForm from './ReviewForm';
import ReviewItem from './ReviewItem';

import {
  createEscape,
  updateEscape,
  deleteEscape,
  getSuggestions,
  addEscape,
  createReview,
  listReviews,
} from '../../actions';


class EscapeAdder extends Component {

  state = {};

  closeAddReview() {
    this.setState({ reviewing: false, reviewingEscape: null });
  }

  showReviewForm(escape) {
    this.setState({ reviewing: true, reviewingEscape: escape });
  }

  addReview(e, values) {
    e.preventDefault();
    console.log('ADD REVIEW', values);
    this.props.createReview(values)
      .then(resp => {
        console.log('create review resp', resp);
        if (resp.error) return;
        this.closeAddReview();
        if (this.props.onChange) this.props.onChange();
        if (this.props.onDone) this.props.onDone();
        if (this.props.showProfileLink) this.showProfileLink();
      });
  }

  renderAddReview() {
    let escape = this.state.reviewingEscape || {};
    if (!escape) return null;
    if (!this.props.user) return null;
    let profile = this.props.user.profile;
    let room = this.props.room;
    if (!room) return null;

    return (
      <Modal show={!!this.state.reviewing}>
        <Modal.Header closeButton onHide={() => this.closeAddReview()}>
          <Modal.Title>Review {room.name}</Modal.Title>
        </Modal.Header>
        <ReviewForm
          modal={true}
          values={{
                  profileId: profile.id,
                  escapeId: escape.id,
                  roomId: room.id,
                  }}
          errors={this.props.errors.review}
          onSubmit={(e, values) => this.addReview(e, values)}
          onCancel={() => this.closeAddReview()}
          buttonText="Add Review"
          cancelText="Cancel"
          room={room}
        />
      </Modal>
    );
  }

  addEscape(e, values) {
    e.preventDefault();
    console.log('ADD ESCAPE:', values);
    this.props.addEscape(values)
      .then(resp => {
        console.log('add escape resp', resp);
        if (resp.error) return;
        if (this.props.onChange) this.props.onChange();
        this.closeAddEscape();
        this.setState({ reviewing: true, reviewingEscape: resp });
      });
  }

  showAddEscape() {
    if (this.props.skipToReview) {
      this.showReviewForm(null);
    } else {
      this.setState({ addingEscape: true, closeAddEscape: false });
    }
  }

  closeAddEscape() {
    this.setState({ addingEscape: false, closeAddEscape: true });
  }

  renderAddEscape() {
    console.log('USER', this.props.user);
    if (!this.props.user) return null;
    let profile = this.props.user.profile;
    let rooms = this.props.rooms ? this.props.rooms.items : [];
    let values = {};
    if (this.props.team) {
      values.teamId = this.props.team.id;
    }
    if (this.props.room) {
      values.room = this.props.room;
      values.roomId = this.props.room.id;
    }

    
    let show;
    if (this.state.closeAddEscape) {
      show = false;
    } else {
      show = this.props.addingEscape || this.state.addingEscape;
    }

    return (
      <Modal show={show}>
        <Modal.Header closeButton onHide={() => this.closeAddEscape()}>
          <Modal.Title>Add Escape</Modal.Title>
        </Modal.Header>
        <EscapeForm
          modal={true}
          values={values}
          errors={this.props.errors.escape}
          onSubmit={(e, values) => this.addEscape(e, values)}
          onCancel={() => this.closeAddEscape()}
          buttonText="Add"
          cancelText="Cancel"
          rooms={rooms}
          getSuggestions={(...args) => this.props.getSuggestions(...args)}
          teamMemberships={profile ? profile.teamMemberships : []}
        />
      </Modal>
    );
  }

  showProfileLink() {
    this.setState({ profileLink: true });
  }

  closeProfileLink() {
    this.setState({ profileLink: false });
  }

  renderProfileLink() {
    let user = this.props.user;
    if (!user || !user.profile) return;
    let profile = user.profile;

    return (
      <Modal show={this.state.profileLink}>
        <Modal.Header closeButton onHide={() => this.closeProfileLink()}>
          <Modal.Title>Added Review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="success-icon"><FontAwesome name="check-circle" /></div>
          <div className="success-header">Success!</div>
          <div className="success-message">Added your escape. You can view it on your profile.</div>
          <div className="success-controls">
            <Button bsSize="lg" onClick={() => this.closeProfileLink()}>Close</Button>{' '}
            <Link to={'/p/' + user.username}><Button bsSize="lg">See My Profile</Button></Link>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    // TODO: have a sign up flow in here

    if (!this.props.user || !this.props.user.profile) return null;

    return (
      <div className="EscapeList">
        {this.renderAddEscape()}
        {this.renderAddReview()}
        {this.renderProfileLink()}

        <div onClick={() => this.showAddEscape()}>
          {this.props.children}
        </div>

      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getSuggestions,
    addEscape,
    createReview,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EscapeAdder);



/** WEBPACK FOOTER **
 ** ./src/components/partials/EscapeAdder.js
 **/